<template>
     <div>
    <v-tabs
      v-model="tab"
      centered
      background-color="blue-grey"
      dark
      slider-color="yellow"
    >
      <v-tab to="#general">ARCHIVO GENERAL</v-tab>
      <v-tab to="#cajas">CAJAS</v-tab>
      <v-tab to="#vencidos">EXPEDIENTES VENCIDOS</v-tab>
      <v-tab to="#transferidos">TRANSFERENCIAS</v-tab>

      <v-tabs-items v-model="tab">
        <v-tab-item value="general">
          <v-card flat>
           <archivo-general/>
          </v-card>
        </v-tab-item>
        <v-tab-item value="cajas">
          <v-card flat>
            <cajas/>
          </v-card>
        </v-tab-item>
        <v-tab-item value="vencidos">
          <v-card flat>
            <expedientes-vencidos/>
          </v-card>
        </v-tab-item>
        <v-tab-item value="transferidos">
          <v-card flat>
            <expedientes-transferidos/>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
 

</template>
<script>
import archivoGeneral from '../components/archivo/archivoGeneral.vue'
import expedientesVencidos from '../components/archivo/expedientesVencidos.vue'
import expedientesTransferidos from '../components/archivo/transferencias.vue'
import cajas from '../components/archivo/cajas.vue'
import { mapGetters} from 'vuex'
export default {
    components: {
        archivoGeneral,
        expedientesVencidos,
        expedientesTransferidos,
        cajas
    },
    data: () => ({
        tab:'general'
        
    }),
    computed: {
         ...mapGetters([ "role" ])
    },
    created(){
        if(this.role != 'admin' && this.role != 'super-admin') this.$router.push('/oficios');
    }
}
</script>
